import Page from "../Common/Page";
import React from "react";
import {
  Table,
  Form,
  Button,
  Row,
  Col,
  Input,
  DatePicker,
  Modal,
  Popconfirm,
} from "antd";
import { AuthContext } from "../Auth/Auth";
import moment from "moment";
import { http } from "../Common/http";
import { formatTimeSpan } from "../Common/Utils";
import { Messages } from "../Common/ValidateMessages";

interface DocumentRegistResultItemData {
  applyDocumentImportId: string;
  seq: string;
  procType: string;
  folderName: string;
  importMmethod: string;
  startDatetime: Date;
  endDatetime: Date;
  processingTime: number;
  result: string;
  fileTotalCnt: number;
  fileCompleteCnt: number;
  fileWarningCnt: number;
  fileErrorCnt: number;
  applicantLinkCnt: number;
  linkApplyDocumentImportId: string;
  linkSEQ: number;
  cancelCount: number;
}
interface DocumentRegistResultDetailData {
  applyDocumentImportDetailId: string;
  applyDocumentLinkDestinationId: string;
  seq: number;
  result: string;
  fileName: string;
  message: string;
  applicant: string;
  exam: string;
  document: string;
  subject: string;
}
interface SearchResultRequestData {
  folderName?: string;
  startDatetime?: string;
  endDatetime?: string;
}
interface StateType {
  datas: DocumentRegistResultItemData[];
  selectedRowKeys: React.Key[];
  selectedRow: DocumentRegistResultItemData | null;
  details: DocumentRegistResultDetailData[];
}

export class DocumentRegistResultPage extends React.Component<any, StateType> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;

  constructor(props) {
    super(props);
    this._page = React.createRef<Page>();
    this._form = React.createRef();
    this.state = {
      datas: [],
      selectedRowKeys: [],
      selectedRow: null,
      details: [],
    };
  }
  resultTableColumns = [
    {
      title: <div className="table-title">処理No</div>,
      key: "seq",
      dataIndex: "seq",
      width: "5%",
    },
    {
      title: <div className="table-title">アップロード済フォルダ名</div>,
      key: "folderName",
      render: (
        value: any,
        item: DocumentRegistResultItemData,
        index: number
      ) => {
        if (item.procType === "1") {
          return item.folderName;
        } else if (item.procType === "2") {
          return `【${item.linkSEQ}】${item.folderName}`;
        }
      },
      width: "15%",
    },
    {
      title: <div className="table-title">処理</div>,
      key: "procType",
      render: (
        value: any,
        item: DocumentRegistResultItemData,
        index: number
      ) => {
        if (item.procType === "1") {
          return <span>取込</span>;
        } else if (item.procType === "2") {
          return <span style={{ background: "#FFA7A7" }}>取消</span>;
        }
      },
      width: "5%",
    },
    {
      title: <div className="table-title">処理開始日時</div>,
      key: "startDatetime",
      render: (
        value: any,
        item: DocumentRegistResultItemData,
        index: number
      ) => (
        <span>{moment(item.startDatetime).format("YYYY/MM/DD HH:mm:ss")}</span>
      ),
      width: "7%",
    },
    {
      title: <div className="table-title">処理終了日時</div>,
      key: "endDatetime",
      render: (
        value: any,
        item: DocumentRegistResultItemData,
        index: number
      ) => (
        <span>{moment(item.endDatetime).format("YYYY/MM/DD HH:mm:ss")}</span>
      ),
      width: "7%",
    },
    {
      title: <div className="table-title">処理時間</div>,
      key: "processingTime",
      render: (
        value: any,
        item: DocumentRegistResultItemData,
        index: number
      ) => <span>{formatTimeSpan(item.processingTime)}</span>,
      width: "4%",
    },
    {
      title: <div className="table-title">状態</div>,
      key: "result",
      render: (
        value: any,
        item: DocumentRegistResultItemData,
        index: number
      ) => {
        // 0：処理中 1:正常 2:警告 3:エラー
        if (item.result === "1") {
          return <span>正常</span>;
        } else if (item.result === "2") {
          return <span>警告</span>;
        } else if (item.result === "3") {
          return <span>エラー</span>;
        }
      },
      width: "5%",
    },
    {
      title: <div className="table-title">入力ファイル数</div>,
      key: "fileTotalCnt",
      dataIndex: "fileTotalCnt",
      width: "5%",
    },
    {
      title: <div className="table-title">処理ファイル数</div>,
      key: "fileCompleteCnt",
      dataIndex: "fileCompleteCnt",
      width: "5%",
    },
    {
      title: <div className="table-title">処理志願者数</div>,
      key: "applicantLinkCnt",
      dataIndex: "applicantLinkCnt",
      width: "5%",
    },
    {
      title: <div className="table-title">警告ファイル数</div>,
      key: "fileWarningCnt",
      dataIndex: "fileWarningCnt",
      width: "5%",
    },
    {
      title: <div className="table-title">エラーファイル数</div>,
      key: "fileErrorCnt",
      dataIndex: "fileErrorCnt",
      width: "5%",
    },
    // {
    //   title: "取消",
    //   key: "action",
    //   render: (
    //     value: any,
    //     item: DocumentRegistResultItemData,
    //     index: number
    //   ) => {
    //     if (item.procType === "1" && item.cancelCount === 0) {
    //       return (
    //         <Popconfirm
    //           title="提出書類の取込を取消してもよろしいですか？"
    //           okText="はい"
    //           cancelText="いいえ"
    //           onConfirm={() => this.doCancel(item)}
    //         >
    //           <Button type="primary" htmlType="button">
    //             取消
    //           </Button>
    //         </Popconfirm>
    //       );
    //     }
    //   },
    // },
  ];
  detailTableColumns = [
    {
      title: <div className="table-title">連番</div>,
      key: "no",
      render: (
        value: any,
        item: DocumentRegistResultDetailData,
        index: number
      ) => <span>{index + 1}</span>,
      width: "5%",
    },
    {
      title: <div className="table-title">状態</div>,
      key: "result",
      render: (
        value: any,
        item: DocumentRegistResultDetailData,
        index: number
      ) => {
        // 0：処理中 1:正常 2:警告 3:エラー
        if (item.result === "1") {
          return <span>正常</span>;
        } else if (item.result === "2") {
          return <span>警告</span>;
        } else if (item.result === "3") {
          return <span>エラー</span>;
        }
      },
      width: "5%",
    },
    {
      title: <div className="table-title">ファイル名</div>,
      key: "fileName",
      dataIndex: "fileName",
      width: "10%",
    },
    {
      title: <div className="table-title">メッセージ</div>,
      key: "message",
      dataIndex: "message",
      width: "25%",
    },
    {
      title: <div className="table-title">処理先:志願者</div>,
      key: "applicant",
      dataIndex: "applicant",
      width: "10%",
    },
    {
      title: <div className="table-title">処理先:試験</div>,
      key: "exam",
      dataIndex: "exam",
      width: "25%",
    },
    {
      title: <div className="table-title">処理先:提出書類</div>,
      key: "document",
      dataIndex: "document",
      width: "10%",
    },
    {
      title: <div className="table-title">処理先:試験科目</div>,
      key: "subject",
      dataIndex: "subject",
      width: "10%",
    },
  ];

  doCancel = async (record: DocumentRegistResultItemData) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      const result = await http<undefined>({
        path: `/ApplyDocument/cancel/${record.applyDocumentImportId}`,
        method: "get",
        accessToken: this.context.accessToken,
        noResponsebody: true,
      });
      this._page.current?.setState({ isPageLoading: false });
      if (result.ok) {
        this.setState({ details: [], selectedRow: null, selectedRowKeys: [] });
        this._form.current.submit();
      } else {
        Modal.error({
          content: Messages["ERR-028"],
        });
      }
    } catch (error) {
      console.log(error);
      Modal.error({
        content: Messages["ERR-028"],
      });
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onFinish = async (values: any) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      this.setState({ details: [], selectedRow: null, selectedRowKeys: [] });
      let start = "";
      let end = "";
      if (values.processStart) {
        if (values.processStart[0]) {
          start = moment(values.processStart[0]).format("YYYY/MM/DD HH:mm:ss");
        }
        if (values.processStart[1]) {
          end = moment(values.processStart[1]).format("YYYY/MM/DD HH:mm:ss");
        }
      }

      const postData: SearchResultRequestData = {
        folderName: values.folderName ? values.folderName : undefined,
        startDatetime: start,
        endDatetime: end,
      };
      const result = await http<
        DocumentRegistResultItemData[],
        SearchResultRequestData
      >({
        path: "/ApplyDocument/searchresult",
        method: "post",
        body: postData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        this.setState({
          datas: result.body,
        });
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };
  selectRow = async (record: DocumentRegistResultItemData) => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      const selectedRowKeys: string[] = [];
      selectedRowKeys.push(record.applyDocumentImportId);
      this.setState({ selectedRowKeys: selectedRowKeys, selectedRow: record });
      const result = await http<DocumentRegistResultDetailData[]>({
        path: `/ApplyDocument/searchresultdetail/${record.applyDocumentImportId}`,
        method: "get",
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        this.setState({
          details: result.body,
        });
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  render(): React.ReactNode {
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      columnWidth: 0,
      renderCell: () => {
        return "";
      },
      hideSelectAll: true,
    };
    return (
      <Page ref={this._page} title="出願時提出書類登録結果確認・取消">
        <div className="data_content">
          <Form
            colon={false}
            className="search_form"
            name="documentRegistResult"
            onFinish={this.onFinish}
            layout="horizontal"
            labelAlign="left"
            ref={this._form}
          >
            <Row>
              <Col span={8}>
                <Form.Item label="アップロード済フォルダ名" name="folderName">
                  <Input style={{ width: 200 }} maxLength={50} />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="処理日時" name="processStart">
                  <DatePicker.RangePicker
                    showTime={{ format: "HH:mm:ss" }}
                    format="YYYY-MM-DD HH:mm:ss"
                    allowEmpty={[true, true]}
                  />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    検索
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <h4>取込処理一覧 ※直近500件までの処理結果を表示しています</h4>
          <Table
            rowKey={(record) => record.applyDocumentImportId}
            bordered
            pagination={false}
            columns={this.resultTableColumns}
            dataSource={this.state.datas}
            scroll={{ y: "200px" }}
            rowSelection={{
              ...rowSelection,
            }}
            onRow={(record) => ({
              onClick: () => {
                this.selectRow(record);
              },
            })}
          />
          {this.state.details && this.state.details.length > 0 ? (
            <div style={{ marginTop: "10px" }}>
              <Row>
                <Col span={20}>
                  <h4>処理結果</h4>
                </Col>
                <Col span={4}>
                  <Popconfirm
                    disabled={
                      this.state.selectedRow == null ||
                      !(
                        this.state.selectedRow.procType === "1" &&
                        this.state.selectedRow.cancelCount === 0
                      )
                    }
                    title="提出書類の取込を取消してもよろしいですか？"
                    okText="はい"
                    cancelText="いいえ"
                    onConfirm={() => this.doCancel(this.state.selectedRow!)}
                  >
                    <Button
                      type="primary"
                      htmlType="button"
                      disabled={
                        this.state.selectedRow == null ||
                        !(
                          this.state.selectedRow.procType === "1" &&
                          this.state.selectedRow.cancelCount === 0
                        )
                      }
                    >
                      取消処理実行
                    </Button>
                  </Popconfirm>
                </Col>
              </Row>
              <Table
                rowKey={(record) => record.applyDocumentLinkDestinationId}
                bordered
                pagination={false}
                columns={this.detailTableColumns}
                dataSource={this.state.details}
                scroll={{ y: "calc(100vh - 570px)" }}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </Page>
    );
  }
}
